export default __webpack_public_path__ + "static/media/metamask.d4e89c6c.svg";